/* THIS FILE IS AUTO-GENERATED – DO NOT EDIT */

import {forwardRef} from 'react'

/**
 * @public
 */
export const OlistIcon = forwardRef(function OlistIcon(
  props: React.SVGProps<SVGSVGElement>,
  ref: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      data-sanity-icon="olist"
      width="1em"
      height="1em"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...props}
    >
      <path
        d="M7.5 18.5V19H8.30902L7.94721 18.2764L7.5 18.5ZM7.5 16.5L7.94721 16.7236L8.30902 16H7.5V16.5ZM7 17.5L6.55279 17.2764L6.44098 17.5L6.55279 17.7236L7 17.5ZM6.5 6.5H7V6H6.5V6.5ZM6 13.5L5.55279 13.2764L5.19098 14H6V13.5ZM7 11.5L7.44721 11.7236L7.80902 11H7V11.5ZM10 8H19V7H10V8ZM10 13H19V12H10V13ZM10 18H19V17H10V18ZM5 19H7.5V18H5V19ZM7.5 16H5V17H7.5V16ZM7.94721 18.2764L7.44721 17.2764L6.55279 17.7236L7.05279 18.7236L7.94721 18.2764ZM7.44721 17.7236L7.94721 16.7236L7.05279 16.2764L6.55279 17.2764L7.44721 17.7236ZM5 7H6.5V6H5V7ZM5 9H6.5V8H5V9ZM6.5 9H8V8H6.5V9ZM6 6.5V8.5H7V6.5H6ZM8 13H6V14H8V13ZM6.44721 13.7236L7.44721 11.7236L6.55279 11.2764L5.55279 13.2764L6.44721 13.7236ZM7 11H5V12H7V11Z"
        fill="currentColor"
      />
    </svg>
  )
})
